import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first } from 'rxjs/operators'

import { Cart } from '../models/cart'
import { Mapper } from '../services/mapper.service'
import { Store } from './store'
import { ApiService } from './api.service'
import { MembershipInvite } from 'app/models'
import { AddMembershipsToSaleGroupResponse, AddMembershipsToSaleGroupRequest } from 'app/models/sale-group'

@Injectable({
  providedIn: 'root'
})
export class CartService extends Store<Cart> {

  constructor(private api: ApiService) {
    super(new Cart({ }))
  }

  public createSaleGroup(
    memdefId: string,
    personaId: number,
    bossOrgId: number,
    affOrgId?: number,
    effectiveAt?: string,
    redirect?: string
  ): void {
    const params: any = {
      membership_data: [
        {
          membership_definition_id: memdefId,
          persona_ids: [personaId]
        }
      ],
      redirect_params: redirect ? redirect : 'memberships',
      boss_organization_id: bossOrgId
    }

    if (affOrgId) {
      params.affiliation_organization_id = affOrgId
      params.membership_data[0].associated_organization_ids = [affOrgId]
    }
    if (effectiveAt) {
      params.membership_data[0].effective_at = effectiveAt
    }
    this.api.post('memberships/add_memberships_to_sale_group', params, { }).pipe(first())
      .subscribe((data: any) => {
          const cart = Mapper.as<Cart>(data.result, Cart)
          this.subject.next(cart)
        },
        (err: any) => {
          this.subject.next(new Cart({ errors: ['There was an error']}))
        }
      )
  }

  public submitSaleGroup(request: AddMembershipsToSaleGroupRequest): Promise<AddMembershipsToSaleGroupResponse> {
    return this.api.post('memberships/add_memberships_to_sale_group', request)
      .toPromise()
      .then((data) => data.result as AddMembershipsToSaleGroupResponse)
  }

  public evaluatePricingRules(orgId: number, membershipData: {
    persona_ids: number[],
    membership_definition_id: string,
    associated_organization_ids?: number[]
  }[]): Observable<any> {
    return this.api.post('memberships/evaluate_pricing_rules', { boss_organization_id: orgId, membership_data: membershipData })
  }
}
